import { Logo } from '@sortlist-frontend/design-system/ssr';
import { TFunction } from '@sortlist-frontend/translation/server-only';
import { formatCustomDate } from '@sortlist-frontend/utils';

import { NavigationData } from '../Layout';
import { DomainsDropdown } from './DomainsDropdown';
import { DomainsLinks } from './DomainsLinks';
import { Menus } from './Menus';
import { Others } from './Others';
import { Socials } from './Socials';

export type FooterProps = {
  showRankUpdated?: boolean;
  navigationData: NavigationData;
  t: TFunction;
  isStatic?: boolean;
};

export const Footer = (props: FooterProps) => {
  const { showRankUpdated, t, isStatic = false, navigationData } = props;

  return (
    <footer id="footer" className="w-full bg-secondary-50 p-4 pt-16">
      <div className="mx-auto flex w-full max-w-6xl flex-col">
        <div className="px-2 md:px-4">
          <Logo className="mb-16" inversion="negative" height={24} />
        </div>
        <div className="flex flex-col md:flex-row">
          <div data-testid="footer-description-container" className="max-w-96 px-2 pr-16 md:px-4">
            <p className="font-medium leading-snug">{t('common:footer.descriptionTitle')}</p>
            <p className="leading-snug text-secondary-500 text-sm mt-2">{t('common:footer.description_V2')}</p>
            {isStatic ? null : <Socials />}
          </div>

          <Menus {...props} />
        </div>
        <div className="flex flex-col md:flex-row md:items-center md:justify-between">
          <div className="md:order-1">{isStatic ? <DomainsLinks {...props} /> : <DomainsDropdown {...props} />}</div>
          <div className="my-4 p-2 md:p-4">
            <Others {...props} />
            {showRankUpdated ? (
              <span className="mt-2 text-sm text-secondary-500">
                {t('common:footer.rankingUpdated', {
                  date: formatCustomDate(
                    new Date(),
                    { day: '2-digit', month: 'long', year: 'numeric' },
                    navigationData.locale,
                  ),
                })}
              </span>
            ) : null}
          </div>
        </div>
      </div>
    </footer>
  );
};
